/**
 * Hệ thống tài khoản
 */
export default {
  Account_1: '1',
  Account_2: '2',
  Account_1112: '1112',
  Account_1122: '1122',
};
